import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";

import Sortable from "../../../../componets/Sortable";
import { reorderFrames } from "../../../../actions/mine_craft/framesActions";

const Reorder = () => {
  const dispatch = useAppDispatch();
  const reorderIds = useAppSelector(state => state.mineCraft.frames.reorderIds);
  const frames = useAppSelector(state => state.mineCraft.frames.entities);

  function onClickSave(ids: any[]) {
    dispatch(reorderFrames({ ids }));
  }

  return (
    <div className='v-frames-reorder'>
      <h6 className="v-content-label o-sm">Reorder</h6>

      {
        reorderIds &&
          <Sortable
            ids={reorderIds}
            onClickSave={onClickSave}
            imageKey={'image_url'}
            items={frames}
            titleKey='name'
          />
      }
    </div>
  )
}

export default Reorder;
